import useSWR from 'swr';
import { SwrReturnType } from '~/models/Api';
import { DealConstructionItem } from '~/models/DealConstructionItem';

const paths = {
  index: 'vendors/deals/:deal_id/deal_construction_items'
};

type TIndex = (id: number | null) => SwrReturnType<DealConstructionItem[]>;
type ReturnType = {
  index: TIndex;
};

export const useDealConstructionItems = (): ReturnType => {
  const index: TIndex = (dealId: number | null) => {
    const { data, mutate, error } = useSWR<DealConstructionItem[]>(
      dealId === null ? null : paths.index.replace(':deal_id', String(dealId))
    );
    return {
      data: data ?? null,
      mutate,
      isLoading: !data && !error,
      error
    };
  };
  return { index };
};
